import React, { FC, ReactNode } from 'react';
import { cn } from '@thingslog/ui-components';

interface PortalPageShellProps {
  children: ReactNode;
  className?: string;
  maxWidth?: 'none' | 'form';
}

export const PortalPageShell: FC<PortalPageShellProps> = ({
  children,
  className,
  maxWidth = 'none',
}: PortalPageShellProps) => {
  return (
    <main
      className={cn(
        'w-full min-w-0 flex-1 px-3 py-3 sm:px-4 lg:px-5',
        maxWidth === 'form' && 'mx-auto max-w-[96rem]',
        className
      )}
    >
      {children}
    </main>
  );
};
